if (window.location.pathname.includes("/products")) {
    const interval = setInterval(() => {
        const qtyTable = document.querySelector('.bss-b2b-cart-item-qty-table');
        const productPrice = document.querySelector('.product-price');
        
        if (qtyTable && productPrice) {
            productPrice.insertAdjacentElement('afterend', qtyTable);
            
            clearInterval(interval);
        }
    }, 200); 
    setTimeout(() => {
        clearInterval(interval);
    }, 8000);
}

document.addEventListener("DOMContentLoaded", () => {
  const inputSearch =  document.querySelector('.form-control[name="q"]');
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});
